import Image from 'app/Components/Shared/Image/image';
import React , {useState, useRef, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReactSelect from 'app/Components/Shared/ReactSelect/ReactSelect';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import {createWorkOrder, BenefitCustomerStep, resetState} from './BenefitCustomerBlockSlice';


const BenefitPage = (props) => {
  const dispatch = useDispatch();
  const step = useSelector(state => state.benefitCustomerBlock.currentStep);
  const clName = step != BenefitCustomerStep.SelectBenefit ? 'msg' : '';
  const userDetails = useSelector(state => state.authentication.loginData.userDetails);
  const [selectedBenefit, setSelectedBenefit] = useState(null);
  const [error, setError] = useState(null);
  const titleRef = useRef(null);

  useEffect(() => {
    return () => {
      dispatch(resetState());
    };
  }, []);

  useEffect(() => {
    const benefitList = props.iContent.benefitList?.value || [];
    if (benefitList.length === 1 && !selectedBenefit) {
      setSelectedBenefit({ key: benefitList[0], value: benefitList[0] });
    }
  }, [props.iContent.benefitList?.value]);

  const submitBenefit = () => {
    if(!selectedBenefit){
      setError('יש לבחור את ההטבה');
    }
    else {

        let request = {
          orderType: 'BENEFIT',
          subscriber: userDetails.contactNumber,
          identityNumber: userDetails.IDNumber,
          banList: [],
          psidList: [],
          movingApartment: null,
          saleJet: null,
          benefitCustomer : {
            benefitDescription: selectedBenefit.key,
            selectedAccount: userDetails.contactNumber,
          }
        }

      dispatch(createWorkOrder(request));
      }
  }


  const renderSelectionStep = () => {
    return (
      <>
      {props.iContent.title?.value && (
        <div className='l-title'>{props.iContent.title.value}</div>
      )}
      {props.iContent.subTitle?.value && (
        <div className='m-title'>{props.iContent.subTitle.value}</div>
      )}

      <div className='benefit-customer-selection-container'>
        <ReactSelect
          getOptionLabel={(option) => option.key}
          getOptionValue={(option) => option.key}
          placeholder='בחרו הטבה מרשימה'
          value={selectedBenefit}
          name='selected'
          options={(props.iContent.benefitList?.value || []).map((item) => ({key: item, value: item}))}
          onChange={(e) => {
            setError('')
            setSelectedBenefit(e);
          }}
        />
      </div>
      <div className='button-wrapper'>
        {error && <div className='error'>{error}</div>}
        <BtnSubmit text='המשך' onclick={submitBenefit}/>
      </div>
      {props.iContent.mainText?.value && (
        <div className='main-text' dangerouslySetInnerHTML={{ __html: props.iContent.mainText.value }} />
      )}


      </>
    )
  }

  const renderMessageStep = () => {
    const msgTitle = step === BenefitCustomerStep.Success ? 'קיבלנו!' : 'משהו השתבש ולא הצלחנו לשלוח את הפנייה';
    const msgSubTitle = step === BenefitCustomerStep.Success ? 'ההטבה תתעדכן תוך שני ימי עסקים': 'ניתן לפנות לנציג ב-*'+ window.Config.technicalSupportPhone;
    const icon = step === BenefitCustomerStep.Success ? require('./icons/success.svg') : require('./icons/error.svg');
    return (
      <div className='message-container'>
        <div className='message-icon-container'><Image src={icon} alt='icon' /></div>
        <div className='l-title'>{msgTitle}</div>
        <div className='m-title'>{msgSubTitle}</div>
      </div>
    )
  }

  const getCurrentStep = () => {
    switch(step){
      case BenefitCustomerStep.SelectBenefit:
        return renderSelectionStep();
      case BenefitCustomerStep.Success:
      case BenefitCustomerStep.Failed:
        return renderMessageStep();
    }
  }


  return (
    <div className={`benefit-customer-container ${clName}`}>
        {getCurrentStep()}
    </div>
  );
};

export default BenefitPage;
